module.exports = __webpack_public_path__ + "static/media/Instructions3.f5712c2e.png";